<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Attributs devant être renseigné(s)</mat-label>
            <mat-select data-select-step formControlName="attributes" multiple required tabindex="10">
                @for (item of _attributes; track item.id) {
                    <mat-option data-select-listing-type-option [value]="item.id">
                        {{ item.header }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['attributes']?.required && (dataForm.controls['attributes']?.dirty || dataForm.controls['attributes'].touched)) {
                <mat-error data-input-role-error>Au moins un attribut doit être selectionnée.</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO attributes" matTooltipPosition="right"></fa-icon>
    </div>
</form>
